import api from './api';
import ModalPopUp from '../helpers/modal';

const apiUrl = PROCESSING_API_URL; // eslint-disable-line no-undef

export const clearUserCache = () => {
  // XXX: we need to clean user information from cache, so we get new user details from api
  return api.post('/api/terms-and-conditions/accept/');
}

const acceptTermsOfService = () => {
  const errorMessage = document.getElementById('acceptTermsOfServiceError');
  if (errorMessage !== null) {
    errorMessage.style.display = 'none';
  }
  api.post(`${apiUrl}/public/processing/v1/user/terms`, {
    isTosAccepted: true,
  }).then(() => {
    clearUserCache();
    ModalPopUp.closeModal('acceptTermsOfServiceModal');
  }).catch(() => {
    errorMessage.style.display = 'block';
  });
};

document.addEventListener('DOMContentLoaded', () => {
  const acceptButton = document.getElementById('acceptTermsOfServiceBtn');

  if (acceptButton === null) {
    return;
  }

  acceptButton.addEventListener('click', acceptTermsOfService);
});

export const checkTermsAndConditionsStatus = () => {
  return api.get('/api/terms-and-conditions/is-accepted/').then(({ data }) => {
    if (data.isTermsAndConditionsAccepted) {
      return;
    }
    ModalPopUp.showForcedModal('acceptTermsOfServiceModal');
  })
}
